import * as actions from './actionsTypes';

const initialData = {
  loading: false,
  saveLoading: false,
  areasLength: 0,
  areas: [],
  areaError: "",
  areaFormErrors: "",
}

export default function areasReducer(state = initialData, action){
  switch (action.type) {
    case actions.LOADING_AREAS:
      return {...state, loading: action.payload }
    case actions.SAVE_LOADING_AREAS:
      return {...state, saveLoading: action.payload }
    case actions.GET_AREAS:
      return {...state, areas: action.payload.areas, areasLength: action.payload.areasLength}
    case actions.FORM_FAIL:
      return { ...state, areaFormErrors: action.payload };
    case actions.AREAS_FAIL:
      return { ...state, areaError: action.payload };
    default:
      return state
  }
}